/**
 * Awards blocks bundle (assets/js/awards.js, handle opti-awards).
 *
 * Enqueued only by the Awards templates that need it (blocks, winners archive). Build:
 * `npx gulp awardsScripts`.
 */

import initArchive from './archive';
import initBallot from './ballot';
import initCountdowns from './countdown';
import initHero from './hero';
import initPrize from './prize';

// Ballots, heroes and prize banners first, so they already listen when a countdown ends.
document.querySelectorAll('[data-awards-ballot]').forEach(initBallot);
document.querySelectorAll('[data-awards-hero]').forEach(initHero);
document.querySelectorAll('[data-awards-prize]').forEach(initPrize);
initCountdowns();
document.querySelectorAll('[data-awards-archive]').forEach(initArchive);
